import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ImsIoMarketDataProvider } from "../../../Market/services/imsIoMarketDataProvider";

((module) => {

    module.component('imsIoNewProductsSelector', {
        controllerAs: '$ctrl',
        template: require('./imsIoNewProductsSelectorComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: ['$scope', ImsIoMarketDataProvider.componentName, angularServicesNames.$translate, AgGridService.componentName, NewProductsSelectorComponent]
    });

    function NewProductsSelectorComponent(
        this: $TSFixMe,
        $scope: $TSFixMe,
        marketDataProvider: ImsIoMarketDataProvider,
        $translate: ng.translate.ITranslateService,
        agGridService: AgGridService
    ) {

        var $ctrl = this;
        $ctrl.productList = [];
        $ctrl.$onInit = () => {
            $ctrl.dataLoading = marketDataProvider.getNewProductList($ctrl.resolve.countryCode).then((data: $TSFixMe) => {
                $ctrl.productList = data;
                for (const brand of data) {
                    for (const sku of brand.skus) {
                        sku.isSelected = false;
                    }
                }
                $ctrl.gridApi.setRowData($ctrl.productList);
                $ctrl.gridApi.sizeColumnsToFit();
            });


        }

        $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

        $ctrl.productListGridOptions = {
            columnDefs: [
                {
                    field: 'isSelected',
                    headerValueGetter: () => $translate.instant('FORECAST.PARAMETERS.GRID.IS_SELECTED'),
                    checkboxSelection: true,
                    width: 30, suppressMenu: true
                },
                {
                    field: 'name', 
                    headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.BRAND"),
                    suppressMenu: true,
                    filter: "agTextColumnFilter", 
                    filterParams: { newRowsAction: 'keep' },
                    cellRenderer: 'agGroupCellRenderer'
                },
                {
                    field: 'skus.length', 
                    headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.SKU_COUNT"), 
                    suppressMenu: true,
                    filter: "agNumberColumnFilter", 
                    filterParams: { newRowsAction: 'keep' },
                    width: 50
                }
            ],
            onGridReady: function (config: $TSFixMe) {
                $ctrl.gridApi = config.api;
                config.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (config: $TSFixMe) => {
                config.api.sizeColumnsToFit();
            },
            floatingFilter: true,
            angularCompileRows: true,
            defaultColDef: { 
                sortable: true,
                resizable: true
            },
            animateRows: true,
            pagination: true,
            paginationPageSize: 10,
            masterDetail: true,
            rowSelection: 'multiple',
            domLayout: 'autoHeight',
            groupSelectsChildren: true,
            suppressRowClickSelection: true,
            onRowSelected: function (e: $TSFixMe) {
                if (e.node.isSelected()) {
                    if (e.node.detailNode) {
                        e.node.detailNode.detailGridInfo.api.selectAll();
                    } else {
                        for (const sku of e.data.skus) {
                            sku.isSelected = true;
                        }
                    }
                } else {
                    if (e.node.detailNode) {
                        e.node.detailNode.detailGridInfo.api.deselectAll();
                    } else {
                        for (const sku of e.data.skus) {
                            sku.isSelected = false;
                        }
                    }
                }
                e.data.isSelected = e.node.isSelected();
            },
            detailCellRendererParams: {
                detailGridOptions: {
                    columnDefs: [
                        {
                            headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.IS_SELECTED"),
                            width: 30, suppressMenu: true, checkboxSelection: true,
                        },
                        {
                            field: 'name', 
                            headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.SKUS"),
                            suppressMenu: true, 
                            tooltipField: 'name'
                        },
                        {
                            field: 'oracleIndex', 
                            headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.ORACLE_INDEX"),
                            width: 50, 
                            suppressMenu: true
                        },
                        {
                            field: 'bloz', 
                            headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.BLOZ"), 
                            suppressMenu: true,
                            width: 50
                        }
                    ],
                    domLayout: 'autoHeight',
                    rowSelection: 'multiple',
                    groupSelectsChildren: true,
                    suppressRowClickSelection: true,
                    angularCompileRows: true,
                    localeTextFunc: agGridService.transalteFunc,
                    onFirstDataRendered(params: $TSFixMe) {
                        params.api.sizeColumnsToFit();
                    },
                    onModelUpdated: function (e: $TSFixMe) {
                        let node = getParentRowNode(e.api);
                        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                        if (node.isSelected()) {
                            e.api.selectAll();
                        }
                    },
                    onSelectionChanged: function (e: $TSFixMe) {
                        let selectableRowCount = 0;
                        e.api.forEachNode(function (rowNode: $TSFixMe, index: $TSFixMe) {
                            if (rowNode.selectable) {
                                ++selectableRowCount;
                            }
                        });

                        let node = getParentRowNode(e.api);
                        if (node) {
                            if (e.api.getSelectedNodes().length == 0) {
                                // @ts-expect-error ts-migrate(2339) FIXME: Property 'isSelected' does not exist on type 'neve... Remove this comment to see the full error message
                                if (node.isSelected()) {
                                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'setSelected' does not exist on type 'nev... Remove this comment to see the full error message
                                    node.setSelected(false);
                                }
                            } else if (e.api.getSelectedNodes().length == selectableRowCount) {
                                // @ts-expect-error ts-migrate(2339) FIXME: Property 'isSelected' does not exist on type 'neve... Remove this comment to see the full error message
                                if (!node.isSelected()) {
                                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'setSelected' does not exist on type 'nev... Remove this comment to see the full error message
                                    node.setSelected(true);
                                }
                            }
                        }
                    },
                    onRowSelected: function (e: $TSFixMe) {
                        e.data.isSelected = e.node.isSelected();
                    },
                },
                getDetailRowData: function (params: $TSFixMe) {
                    params.successCallback(params.data.skus);
                }
            },
            localeTextFunc: agGridService.transalteFunc,
            getRowHeight: function (params: $TSFixMe) {
                if (params.node && params.node.detail) {
                    const offset = 80;
                    const allDetailRowHeight = params.data.skus.length * 28;
                    return allDetailRowHeight + offset;
                } else {
                    // otherwise return fixed master row height
                    return 30;
                }
            },
        };

        function getParentRowNode(childApi: $TSFixMe) {
            let oracleIndex: $TSFixMe = null;
            childApi.forEachNode(function (rowNode: $TSFixMe, index: $TSFixMe) {
                if (rowNode.data.oracleIndex) {
                    oracleIndex = rowNode.data.oracleIndex;
                }
            });

            var node = null;
            $ctrl.gridApi.forEachNode(function (rowNode: $TSFixMe, index: $TSFixMe) {
                
                if (_.some(rowNode.data.skus, (x: $TSFixMe) => x.oracleIndex == oracleIndex)) {
                    node = rowNode;
                }
            });
            return node;
        }


        $ctrl.events = {
            save: () => {
                const oracleIndexes = [];
                for (const brand of $ctrl.productList) {
                    for (const sku of brand.skus) {
                        if (sku.isSelected) {
                            oracleIndexes.push(sku.oracleIndex);
                        }
                    }
                }
                $ctrl.close({ $value: oracleIndexes });
            },

            cancel: () => {
                $ctrl.dismiss();
            }
        }
    }



})(angular.module('topline.modules'));